import React from 'react';
import { TIMETABLE, WEEK_ORDER } from '../../config/siteConfig';
import './WeekTimetable.css';

// The week's timetable from config/siteConfig.js, Monday first.
// `today` (0–6) highlights that day; `large` is the landing-page size.
export default function WeekTimetable({ today, large = false }) {
  return (
    <ol className={`week ${large ? 'week-lg' : ''}`} aria-label="Weekly timetable">
      {WEEK_ORDER.map(n => {
        const d = TIMETABLE[n];
        const isToday = n === today;
        return (
          <li key={n} className={`wk wk-${d.subject} ${isToday ? 'wk-today' : ''}`} aria-current={isToday ? 'date' : undefined}>
            <span className="wk-day">{large ? d.day : d.short}</span>
            <span className="wk-ic" aria-hidden="true">{d.icon}</span>
            <span className="wk-sub">{d.label}</span>
            {large && <span className="wk-note">{d.subject === 'chess' ? 'Live now' : d.subject === 'rest' ? 'Rest and play' : 'Coming soon'}</span>}
            {isToday && !large && <span className="sr-only">(today)</span>}
          </li>
        );
      })}
    </ol>
  );
}
